import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

import logo from './asset2/rtm-logo.png';
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#333',
    backgroundColor: '#f9f9f9', 
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '2px solid #e0e0e0',
    backgroundColor: '#99d98c', 
    padding: 15,
    borderRadius: 5,
  },
  logo: {
    width: 70,
    height: 50,
    borderRadius: '50%',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'center',
    flex: 1,
  },
  section: {
    marginVertical: 15,
    paddingHorizontal: 10,
    backgroundColor: '#fff',
    borderRadius: 5,
    boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
    padding: 15,
  },
  field: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    padding: 8,
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#fefefe', 
    borderRadius: 3,
  },
  label: {
    fontWeight: 'bold',
    color: '#4a90e2', 
    fontSize: 12,
  },
  value: {
    fontSize: 12,
    color: '#333',
    textAlign: 'right',
  },
  footer: {
    marginTop: 30,
    textAlign: 'center',
    fontSize: 10,
    color: '#555',
    borderTop: '1px solid #e0e0e0',
    paddingTop: 10,
  },
});

const TransactionPDF = ({ transaction }) => (
  <Document>
    <Page size="A4" style={styles.page}>
     
      <View style={styles.header}>
        <Image src={logo} style={styles.logo} />
        <Text style={styles.title}>Transaction Details</Text>
      </View>
      <View style={styles.section}>
        {[
          { label: 'Scheme Name:', value: transaction.schemeName },
          { label: 'Scheme No.:', value: transaction.schemeId },
          { label: 'Date Paid:', value: new Date(transaction.datePaid).toLocaleDateString('en-GB') },
          { label: 'Amount Paid:', value: `₹ ${transaction.amount}/-` },
          { label: 'Mode of Payment:', value: transaction.paymentMethod },
          { label: 'Transaction ID:', value: transaction.transactionId },
          { label: 'Status:', value: transaction.status },
        ].map((field, idx) => (
          <View key={idx} style={styles.field}>
            <Text style={styles.label}>{field.label}</Text>
            <Text style={styles.value}>{field.value}</Text>
          </View>
        ))}
      </View>
      <Text style={styles.footer}>
        This is a system-generated receipt. For any queries, contact@ramthanganagaimaligai.org
      </Text>
    </Page>
  </Document>
);

export default TransactionPDF;
